import React from 'react';

type TabItem<T extends string> = {
  id: T;
  label: React.ReactNode;
};

type Props<T extends string> = {
  items: Array<TabItem<T>>;
  value: T;
  onChange: (next: T) => void;
  right?: React.ReactNode;
};

const Tabs = <T extends string>({ items, value, onChange, right }: Props<T>) => {
  return (
    <div className="tabs">
      <div className="tabs-items">
        {items.map((item) => (
          <div
            key={item.id}
            className={value === item.id ? 'tab active' : 'tab'}
            onClick={() => onChange(item.id)}
          >
            {item.label}
          </div>
        ))}
      </div>
      {right ? <div className="tabs-right">{right}</div> : null}
    </div>
  );
};

export default Tabs;
